import { Languages } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { localeRegistry } from '@/i18n/localeRegistry'
import { useUiStore, type Locale } from '@/stores/uiStore'

export function LanguageSwitcher() {
  const { t } = useTranslation()
  const { locale, setLocale } = useUiStore()

  return (
    <DropdownMenu>
      <Tooltip>
        <TooltipTrigger asChild>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon-sm" aria-label={t('common.lang')}>
              <Languages className="size-4" />
            </Button>
          </DropdownMenuTrigger>
        </TooltipTrigger>
        <TooltipContent>{t('common.lang')}</TooltipContent>
      </Tooltip>
      <DropdownMenuContent align="end">
        {localeRegistry.map((registeredLocale) => (
          <DropdownMenuCheckboxItem
            key={registeredLocale.code}
            checked={locale === registeredLocale.code}
            onCheckedChange={() => setLocale(registeredLocale.code as Locale)}
          >
            {registeredLocale.nativeName}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
